import { IMovementScheduleFli } from '@modeso/types__aumico-lib-annualreport-be';

export interface IMovementScheduleFormFli extends IMovementScheduleFli {
    translatedCaption?: string;
}
